let hints = document.querySelectorAll('[data-hint]');
let textLabelOld;
let textLabelNew;

hints.forEach(function (item) {
  item.addEventListener('focus', hintFocusHandler);
});

function hintFocusHandler(evt) {
  let item = evt.target;
  showHint(item);
  item.addEventListener('blur', hintBlurHandler);
}

function hintBlurHandler(evt) {
  let item = evt.target;
  removeHint(item);
  item.removeEventListener('blur', hintBlurHandler);
}

function showHint(item) {
  let label = getLabel(item.id);
  let sibling = label.nextElementSibling;
  let isLink = sibling.classList.contains('control__link');
  if (label) {
    textLabelOld = saveText(label);
    textLabelNew = getHint(item);
    label.classList.add('control__hint');
    label.textContent = textLabelNew;
  }
  if (isLink) {
    sibling.classList.add('hide');
  }
}

function getLabel(id) {
  return document.querySelector(`label[for=${id}]`);
}

function saveText(label) {
  return label.textContent;
}

function getHint(item) {
  return item.dataset.hint;
}

function removeHint(item) {
  let label = getLabel(item.id);
  let sibling = label.nextElementSibling;
  let isLink = sibling.classList.contains('control__link');
  if (label) {
    label.classList.remove('control__hint');
    label.textContent = textLabelOld;
  }
  if (isLink) {
    sibling.classList.remove('hide');
  }
}
